export default __webpack_public_path__ + "images/sweep2.6ebb6a6d62418ad94b2415b96009e27d.gif";